// extracted by css-extract-rspack-plugin
export default {"buttonLabel":"CLIModePicker-module__buttonLabel__fQIqD"};